import { Component, OnInit, EventEmitter, Output, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { Observable, Subscription } from 'rxjs';
import { GruaMotiusDesestimarFilter } from '../../models/grua-motius-desestimar-filter';


@Component({
  selector: 'app-grua-motius-desestimar-filter',
  templateUrl: './grua-motius-desestimar-filter.component.html',
  styleUrls: ['./grua-motius-desestimar-filter.component.scss']
})
export class GruaMotiusDesestimarFilterComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  filter: GruaMotiusDesestimarFilter;

  @Output() notify: EventEmitter<GruaMotiusDesestimarFilter> = new EventEmitter<GruaMotiusDesestimarFilter>();

  constructor(
    public thisDialogRef: MatDialogRef<GruaMotiusDesestimarFilterComponent>,
    private i18n: I18n,
    @Inject(MAT_DIALOG_DATA) public data) {
    this.filter = data.filter;
  }

  ngOnInit() {
    this.subscription = Observable.fromEvent(document, 'keypress').subscribe((e: KeyboardEvent ) => {
      if (e.key === 'Enter') {
        this.apply();
      }
    });
  }
 
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  reset() {
    this.filter.clear();
    this.apply();
  }

  apply() {
    this.filter.updated();
    this.notify.emit(this.filter);
    this.thisDialogRef.close();
  }

  dismiss() {
    this.thisDialogRef.close();
  }

}
